import type {
  AcademyProfile,
  ApiResponse,
  ManualInviteAccountFor,
  UpdateAcademyProfileData,
  UpdateAcademyProfileSmsData,
} from '@court-sync/shared';
import { apiGet, apiPost, apiPut } from './apiClient';

export interface AcademyProfileWithAcademy extends AcademyProfile {
  academy: { id: string; name: string; slug: string } | null;
}

export const academyProfileService = {
  async getMyProfiles(): Promise<ApiResponse<AcademyProfileWithAcademy[]>> {
    return apiGet<AcademyProfileWithAcademy[]>('/academy-profiles');
  },

  async createProfile(data: {
    academyId?: string;
    academySlug?: string;
    firstName: string;
    lastName: string;
    email?: string;
    phone?: string;
    smsConsent?: boolean;
    manualInviteToken?: string;
    manualInviteAccountFor?: ManualInviteAccountFor;
    /** Standalone academy registration — adds self-student to owner roster */
    ensureSelfStudentRosterEntry?: boolean;
  }): Promise<ApiResponse<AcademyProfile>> {
    return apiPost<AcademyProfile>('/academy-profiles', data);
  },

  async updateProfile(
    academySlug: string,
    data: UpdateAcademyProfileData
  ): Promise<ApiResponse<AcademyProfile>> {
    return apiPut<AcademyProfile>(`/academy-profiles/${encodeURIComponent(academySlug)}`, data);
  },

  async updateSmsPreferences(
    academySlug: string,
    data: UpdateAcademyProfileSmsData
  ): Promise<ApiResponse<AcademyProfile>> {
    return apiPut<AcademyProfile>(`/academy-profiles/${encodeURIComponent(academySlug)}/sms`, data);
  },
};
